import { IStore } from '../../index'

const getInfoModalIsOpen = (state: IStore) => {
  return state.userAccount.infoModal.open
}

export default getInfoModalIsOpen
